module.exports = __webpack_public_path__ + "IMG_3280.png?09139e9f0798e91f4af151d9e7c6751e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG_3280.png
// module id = 84
// module chunks = 0